import { put, getByKey, clear } from './utils/transactionHelpers'

export const saveRequestDetails = async requestDetails => {
    try {
        // Ensure each request has an 'id' set to 'salesforceId'
        const formattedData = requestDetails.map(request => {
            if (!request.id && request.salesforceId) {
                request.id = request.salesforceId
            }
            return request
        })

        // Insert each request into IndexedDB
        const putPromises = formattedData.map(request =>
            put('requestsDetails', request),
        )
        await Promise.all(putPromises)
        return true
    } catch (error) {
        console.error('Failed to save requests:', error)
        return false
    }
}

export const getRequestDetails = async requestIds => {
    try {
        // Get each request detail by ID
        return Promise.all(
            requestIds.map(async id => {
                try {
                    return await getByKey('requestsDetails', id)
                } catch (error) {
                    // Handle individual failures without failing the whole batch
                    console.warn(
                        `Failed to fetch request detail ID ${id}:`,
                        error,
                    )
                    return null
                }
            }),
        )
    } catch (error) {
        console.error('Failed to fetch request details:', error)
        return []
    }
}

export const getRequestDetailsById = async requestId => {
    try {
        return await getByKey('requestsDetails', requestId)
    } catch (error) {
        console.error('Failed to fetch request detail by ID:', error)
        return null
    }
}

export const deleteAllRequestDetails = async () => {
    try {
        await clear('requestsDetails')
        console.log('All request details deleted successfully')
    } catch (error) {
        console.error('Error deleting request details:', error)
        throw error
    }
}
